import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from './auth.contract'

export const isAuthenticatedGuard: CanActivateFn = async () => {
  const router = inject(Router)
  const auth = inject(AuthService)
  const result = await auth.isLoggedIn()
  if (!result) {
    router.navigate(['unauthenticated'])
  }
  return result
}
